import videojs from 'video.js';
import './nested-menu-with-audio-tracks';

const Component = videojs.getComponent('Component');
const arrowRightSvg = '<svg width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.5 13C4.23367 10.4616 5.26633 9.53841 8 7L1.5 1" stroke="#DBA742" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';

class SettingsMenu extends Component {
  constructor(player, options) {
    super(player, options);
    this.options = options;
    this.hide();
    this.nestedMenuWithAudiotracks = this.addChild('nestedMenuWithAudiotracks');

    player.on('click', (evt) => {
      let el = evt.target;
      // показать вложенное меню с аудиотреками, а это скрыть
      const titleEl = el.closest('.vjs-settings-block__audiotracks-title');
      if (titleEl) {
        this.nestedMenuWithAudiotracks.show();
        videojs.dom.addClass(
          this.$('.vjs-settings-menu__content'),
          'vjs-hidden'
        );
        return;
      }
      // закрываем меню на любом клике
      if (this.hasClass('vjs-hidden')) return;
      while (el) {
        if (videojs.dom.hasClass(el, 'vjs-settings-button')) return;
        if (videojs.dom.hasClass(el, 'vjs-settings-menu__content')) return;
        if (videojs.dom.hasClass(el, 'vjs-settings-menu__nested-menu')) return;
        el = el.parentElement;
      }
      this.hide();
    });
  }

  buildCSSClass() {
    return `vjs-settings-menu ${super.buildCSSClass()}`;
  }

  createEl() {
    let el = super.createEl('div', {
      className: this.buildCSSClass(),
      tabIndex: -1
    }, {
      role: 'dialog'
    });
    const content = super.createEl('div', {
      className: 'vjs-settings-menu__content'
    });
    el.appendChild(content);
    return el;
  }

  show() {
    let htmls = [];
    for (const [componentName, title] of Object.entries(this.options.items)) {
      let html;
      if (componentName === 'AudiotracksButton') {
        html = this.getTitleHtmlForAudiotracks(title);
      } else if (componentName === 'SubtitlesButton') {
        html = this.getSubtitlesHtml(title);
      } else {
        html = this.getHtmlByControlBarButton(componentName, title);
      }
      if (html) htmls.push(html);
    }
    const contentEl = this.$('.vjs-settings-menu__content');
    contentEl.innerHTML = htmls.join('<hr>');
    super.show();
    // обработка клика по базовым кнопкам
    for (const spanEl of contentEl.querySelectorAll('span')) {
      const id = spanEl.getAttribute('data-id');
      this.on(spanEl, 'click', () => {
        document.getElementById(id).click();
        this.hide();
      });
    }
    // обработка клика по переключателю субтитров
    const subtitlesTogglerEl = contentEl.querySelector('label[for="settings-menu__subtitles"]');
    if (subtitlesTogglerEl) {
      this.on(subtitlesTogglerEl, 'click', () => {
        const subtitlesButtonComponent = this.player_.getChild('ControlBar').getChild('SubtitlesButton');
        if (!subtitlesButtonComponent) return;
        const menuItems = subtitlesButtonComponent.$$('.vjs-menu-item');
        for (const item of menuItems) {
          if (videojs.dom.hasClass(item, 'vjs-selected')) continue;
          item.click();
          break;
        }
        this.hide();
      });
    }
    const settingsMenuButton = this.player_.getChild('ControlBar').getChild('settingsMenuButton');
    if (settingsMenuButton) {
      settingsMenuButton.enableOpacity();
    }
  }

  hide() {
    const settingsMenuButton = this.player_.getChild('ControlBar').getChild('settingsMenuButton');
    if (settingsMenuButton) {
      settingsMenuButton.disableOpacity();
    }
    super.hide();
  }

  getTitleHtmlForAudiotracks(title) {
    const audiotracksSettings = this.player_.getChild('audiotracksSettings');
    if (!audiotracksSettings || audiotracksSettings.options_.audiotracksList.items.length <= 1) {
      return;
    }
    return `${this.getStartHtml()}
        <div class="vjs-settings-block__audiotracks-title">
          ${title} ${arrowRightSvg}
        </div>
      </div>`;
  }

  getHtmlByControlBarButton(componentName, title) {
    const component = this.player().getChild('controlBar').getChild(componentName);
    if (!this.hasMenu(component)) return;
    let html = `<div class="vjs-settings-block"><div>${title}</div>`;
    const els = this.getVisibleEls(component);
    if (!this.checkMinNumberEls(els)) return;
    for (let i = 0; i < els.length; i++) {
      const el = els[i];
      const textEl = el.querySelector('span');
      const text = textEl ? textEl.innerText : el.innerText;
      const selected = videojs.dom.hasClass(el, 'vjs-selected');
      const id = `${componentName}#item#${i}`;
      el.setAttribute('id', id);
      html += `<span data-id="${id}" ${selected ? 'class="vjs-selected"' : ''}>${text}</span>`;
    }
    html += '</div>';
    return html;
  }

  getStartHtml() {
    return '<div class="vjs-settings-block">';
  }

  getSubtitlesHtml(title) {
    const subtitlesButtonComponent = this.player_.getChild('ControlBar').getChild('SubtitlesButton');
    if (!subtitlesButtonComponent) return;
    const menuItems = subtitlesButtonComponent.$$('.vjs-menu-item');
    if (menuItems.length <= 1) return;
    const isChecked = videojs.dom.hasClass(menuItems[1], 'vjs-selected');
    return `${this.getStartHtml()}
      <div class="settings-menu__subtitles-title">
        <span>${title}</span>
        <input id="settings-menu__subtitles" type="checkbox" ${isChecked ? 'checked' : ''} />
        <label for="settings-menu__subtitles"></label>
      </div>
    </div>`;
  }

  hasMenu(component) {
    return Boolean(component && component.menu);
  }

  checkMinNumberEls(els) {
    return els.length > 1;
  }

  checkContent() {
    const checkMinNumberVisibleEls = componentName => {
      const component = this.player().getChild('controlBar').getChild(componentName);
      return this.hasMenu(component) && this.checkMinNumberEls(this.getVisibleEls(component));
    };
    return Object.keys(this.options.items).some(checkMinNumberVisibleEls);
  }

  getVisibleEls(component) {
    return Array.from(component.el().querySelectorAll('li'))
      .filter(li => !li.classList.contains('vjs-hidden'));
  }
}

Component.registerComponent('settingsMenu', SettingsMenu);
